import React from 'react'

const FreeSampleModal: React.FC<{ product: any, onClose: () => void, onConfirm: () => void }> = ({ product, onClose, onConfirm }) => (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-gradient-to-b from-[#C2FFBC] to-white rounded-xl p-6 max-w-sm relative">
        <button
            onClick={onClose}
            className="absolute top-3 right-3 text-black"
        >
            <span className="text-2xl">✕</span>
        </button>

        <div className="px-4 py-4">
            <h2 className="text-lg font-bold text-center mb-3">
            FREE Sample on Select Orders*
            </h2>
        </div>

        <div className="flex items-center gap-3">
            <img src={product.imageUrl} className="w-20 h-20 object-contain" />
            <div>
            <p className="font-semibold">{product.productName}</p>
            <p className="text-green-600 font-bold">FREE</p>
            </div>
        </div>

        <div className="flex justify-center">
            <button
            onClick={onConfirm}
            className="mt-4 bg-pink-600 text-white py-2 px-4 rounded-lg font-bold"
            >
            ORDER NOW
            </button>
        </div>

        <span className="absolute bottom-3 right-3 text-[9px] font-bold">
            *T&C Apply
        </span>
    </div>
  </div>
)

export default FreeSampleModal
